import React from 'react';
import bg001 from '../assets/images/bg-001.jpg';
import bg002 from '../assets/images/bg-002.jpg';
import bg003 from '../assets/images/bg-003.jpg';
import PageContainer from '../components/layout/PageContainer';

/**
 * SPLICE建築企画不動産ページコンポーネント
 * 既存デザインを完全再現
 */
const RealEstatePage: React.FC = () => {
  return (
    <PageContainer pageType="background-image">
      <div className="p-0 overflow-hidden">
        {/* セクション1: はじまりのお手伝い */}
        <div className="position-relative d-flex align-items-center justify-content-center text-white"
             style={{
               backgroundImage: `url(${bg001})`,
               backgroundSize: 'cover',
               backgroundPosition: 'center',
               backgroundRepeat: 'no-repeat',
               padding: '10rem 3rem',
               minHeight: '60vh'
             }}>
          <div className="position-relative w-100 text-center" style={{ zIndex: 2, maxWidth: '900px' }}>
            <h3 className="zen-old-mincho-bold mb-4" style={{ fontSize: '1.8rem', fontWeight: '700', letterSpacing: '0.05em' }}>
              - はじまりのお手伝い -
            </h3>
            <br />
            <p className="zen-old-mincho-medium mb-4" style={{ fontSize: '1.5rem', fontWeight: '500', letterSpacing: '0.05em' }}>
              都心の 小さなお店・小規模事務所 から 素敵な地方暮らし まで
            </p>
            <br />
            <p className="zen-old-mincho-regular m-0" style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
              SPLICE建築企画はあなたの夢に寄り添います。<br />
              既存ストック(遊休不動産)の有効活用を、"建築設計事務所の視点" でバックアップ。<br />
              企画からリノベーションまで、夢の実現をサポートします。<br />
              お洒落なお店・事務所づくり、地方暮らしの第一歩、物件探しから私たちと一緒に始めてみませんか。
            </p>
          </div>
        </div>

        {/* 区切りテキスト */}
        <div className="text-center d-flex align-items-center justify-content-center" style={{ padding: '2rem' }}>
          <p className="zen-old-mincho-medium m-0" style={{ fontSize: '1.5rem', fontWeight: '500', letterSpacing: '0.05em', color: 'var(--color-text)', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
            We are behind you.
          </p>
        </div>

        {/* セクション2: 浅草橋・蔵前エリア */}
        <div className="position-relative d-flex align-items-center justify-content-center text-white"
             style={{
               backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${bg002})`,
               backgroundSize: 'cover',
               backgroundPosition: 'center',
               backgroundRepeat: 'no-repeat',
               padding: '10rem 3rem',
               minHeight: '60vh'
             }}>
          <div className="position-relative w-100 text-end" style={{ zIndex: 2, maxWidth: '900px' }}>
            <h3 className="zen-old-mincho-bold mb-4" style={{ fontSize: '1.8rem', fontWeight: '700', letterSpacing: '0.05em' }}>
              浅草橋・蔵前エリア
            </h3>
            <hr className="my-4 text-white" style={{ width: '100%', border: '1px solid white' }} />
            <p className="zen-old-mincho-regular m-0" style={{ fontSize: '1.2rem', lineHeight: '1.8' }}>
              私たちの事務所は浅草橋駅から徒歩3分。<br />
              下町感溢れるこのエリアには素敵な物件がたくさんあります。
            </p>
            <div className="my-5">
              <button type="button" className="btn btn-primary">街をご紹介</button>
            </div>
          </div>
        </div>

        {/* 区切りテキスト */}
        <div className="text-center d-flex align-items-center justify-content-center" style={{ padding: '2rem' }}>
          <p className="zen-old-mincho-medium m-0" style={{ fontSize: '1.5rem', fontWeight: '500', letterSpacing: '0.05em', color: 'var(--color-text)', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
            Feel free to contact us.
          </p>
        </div>

        {/* セクション3: 街歩きは普段着で */}
        <div className="position-relative d-flex align-items-center justify-content-center"
             style={{
               backgroundImage: `url(${bg003})`,
               backgroundSize: 'cover',
               backgroundPosition: 'center',
               backgroundRepeat: 'no-repeat',
               padding: '10rem 3rem',
               minHeight: '60vh'
             }}>
          <div className="position-relative w-100 text-start" style={{ zIndex: 2, maxWidth: '900px', color: 'var(--color-text)' }}>
            <h3 className="zen-old-mincho-bold mb-4" style={{ fontSize: '1.8rem', fontWeight: '700', letterSpacing: '0.05em' }}>
              街歩きは普段着で
            </h3>
            <hr className="my-4" style={{ width: '100%', border: '1px solid currentColor' }} />
            <p className="zen-old-mincho-regular m-0" style={{ fontSize: '1.2rem', lineHeight: '1.8' }}>
              スタッフの日常。<br />
            </p>
            <div className="my-5">
              <button type="button" className="btn btn-primary">ブログ</button>
            </div>
          </div>
        </div>
      </div>
    </PageContainer>
  );
};

export default RealEstatePage; 